import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DeleteConfirmationModal, ButtonComponent, RegulatoryAddEdit } from '../../shared';
import { Edit, Delete, CircleSpinner } from '../../../assets/svg';
import { deleteRegulatoryIssues, editRegulatoryIssues, popup } from '../../../utils';
import { QUERY_KEYS, REGULATORY_ISSUE, SUCCESS } from '../../../constants';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const RegulatoryIssueOperation = ({ data }) => {
    const queryClient = useQueryClient();
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const deleteRegulatoryIssueMutation = useMutation({
        mutationFn: async () => await deleteRegulatoryIssues({ id: data.id }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.REGULATORY_ISSUE],
                exact: false,
            });
            popup(SUCCESS.SUCCESS_TOAST, REGULATORY_ISSUE.DELETED_MESSAGE);
            setIsDeleteModalOpen(false);
        },
        onError: (err) => {
            popup('error', err.message);
        },
    });
    const handleDeleteClick = ()=>{
         if (data.id) {
             deleteRegulatoryIssueMutation.mutate();
         }
    }

    const editRegulatoryIssueMutation = useMutation({
        mutationFn: async (body) => await editRegulatoryIssues({ id: data.id, body }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.REGULATORY_ISSUE],
                exact: false,
            });
            popup(SUCCESS.SUCCESS_TOAST, REGULATORY_ISSUE.UPDATED_MESSAGE);
            setIsEditModalOpen(false);
        },
        onError: (err) => {
            popup('error', err.message);
        },
    });

    const handleEditClick = ({ broadcast, regulatoryIssue }) => {
        if (data.id) {
            const body = {
                broadcast,
                title: regulatoryIssue.title,
                content: regulatoryIssue.content,
            };
            editRegulatoryIssueMutation.mutate(body);
        }
    };

    return (
        <>
            <div className='d-flex gap-2 align-items-center justify-content-start options-set margin-left-8'>
                <ButtonComponent
                    className='border-0 p-0 bg-transparent'
                    type='button'
                    clickHandler={() => setIsEditModalOpen(true)}
                    id='action-btn'
                >
                    <Edit />
                </ButtonComponent>
                <ButtonComponent
                    className='border-0 p-0 bg-transparent margin-left-8'
                    type='button'
                    clickHandler={() => setIsDeleteModalOpen(true)}
                    id='action-btn'
                >
                    {deleteRegulatoryIssueMutation.isPending ? <CircleSpinner/> : <Delete />}
                </ButtonComponent>
            </div>
            {isEditModalOpen && (
                <RegulatoryAddEdit
                    data={data}
                    isModalOpen={isEditModalOpen}
                    setIsModalOpen={setIsEditModalOpen}
                    handleEditClick={handleEditClick}
                    modalType='edit'
                    isLoading={editRegulatoryIssueMutation.isPending}
                />
            )}
            {isDeleteModalOpen && (
                <DeleteConfirmationModal
                    isDeleteModal={isDeleteModalOpen}
                    setIsDeleteModal={setIsDeleteModalOpen}
                    selectedItemId={data.id}
                    handleDeleteClick={handleDeleteClick}
                    deleteButtonName={REGULATORY_ISSUE.PAGE_NAME}
                    isLoading={deleteRegulatoryIssueMutation.isPending}
                />
            )}
        </>
    );
};

RegulatoryIssueOperation.propTypes = {
    data: PropTypes.object.isRequired,
    debouncedApiCall: PropTypes.func,
};
